import * as React from 'react';
import Loader from '../../components/Loader';
import NotFound from '../NotFound';
import EditProduct from './EditProduct';
import { useRequest, getHeaders } from '../../api/client';
import { ProfileContext, ProfileManager } from '../../profile';
import { RouteComponentProps } from 'react-router';

const product = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/products/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.product : null;
};

const getEntityID = (props: RouteComponentProps<any>) => {
  return props.match.params.productId;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component product={preloadedEntity} />;
    }

    const state = product(getEntityID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component product={state.data} />;
  };
}

export default withState(EditProduct);
